/**
 * @author yyl
 * 功能：字典
 */
import { Service } from '@/tools'

export class CommodityApprovePerm<T extends TUser.CommodityApprovePerm> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.CommodityApprovePerm}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 商品审批权限列表
   */
  portalList = <K extends T['ApiGetPermList']>(): Promise<K['res']> => this.post2('v1/ApiGetPermList')

  /**
   * 新增商品审批权限
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  /**
   *编辑商品审批权限
   */
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  /**
   * 删除商品审批权限
   *
   */
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)
}
